// SPDX-License-Identifier: AGPL-3.0-or-later

/**
 * Visionary slot indices are stored 0-based (first Visionary = 0).
 * User-facing labels are 1-based (#1, #2, …).
 */
export function formatVisionarySequenceLabel(sequence: number): string {
	return `#${sequence + 1}`;
}
